import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaSpacing, YodaFontSize } from 'yoda-ui/yodaTheme';

export const MayaMenuEntryStyles: SxProps<Theme> = {
  border: 'none',
  textAlign: 'left',
  paddingX: YodaSpacing.none,
  paddingY: YodaSpacing.none,
  fontSize: YodaFontSize.medium,
  cursor: 'pointer',
  background: YodaColors.transparent,
  color: YodaColors.gray9,
  minHeight: '1px',
  textTransform: 'capitalize',
  padding: '5px 10px',

  '&:hover': {
    color: YodaColors.blue7,
    background: YodaColors.transparent,
  },

  '&[data-current="true"]': {
    background: YodaColors.transparent,
    color: YodaColors.blue7,
  },
};

export const MayaMenuSecondaryLevelEntryStyles: SxProps<Theme> = {
  paddingX: YodaSpacing.xSmall,
  paddingY: YodaSpacing.xxSmall,

  '.MuiButton-root': {
    paddingX: YodaSpacing.xSmall,
    paddingY: YodaSpacing.xxSmall,
  },
};
